import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';
import { Modal } from 'react-bootstrap';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import Toggle from 'react-toggle';
import Select from 'react-select';
import InputMask from 'react-input-mask';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

class StaffCerficationsConsolidated extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      modal: false,
      modal_suppliers: false,
      loaded: 0,
      certifications_ids: '',
      aircraft_model_id: [],
      aircraft_model_subtype_id: [],
      staff_ids: '',
      active: 1,
      hide_columns: 0,
      certifications_list: [],
      certifications_index: [],
      staff_certifications: [],
      aircraft_models_list: [],
      staff_list: [],
      search_layout_lists: [],
      titles: {},
      linha: [],
      view_table: 0,
      trainings_list: [],
      checkbox_marked_ids: [],
      checkbox_marked_data: [],
      suppliers_by_certification: {},
      payload: {},
      checkbox_changed: 0,
      training_id: null,
      add_loading: false,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.searchStaffCertifications = this.searchStaffCertifications.bind(this);
    this.exportStaffCertifications = this.exportStaffCertifications.bind(this);
    this.loadData = this.loadData.bind(this);
    this.exportCsv = this.exportCsv.bind(this);
    this.rowFormat = this.rowFormat.bind(this);
    this.openModal = this.openModal.bind(this);
    this.saveLayout = this.saveLayout.bind(this);
    this.onRowSelect = this.onRowSelect.bind(this);
    this.onSelectAll = this.onSelectAll.bind(this);
    this.add = this.add.bind(this);
    this.certificationsModal = this.certificationsModal.bind(this);
    this.saveModalCertifications = this.saveModalCertifications.bind(this);

  }

  // Handlers
  handleSelectChangeModal(name, index, event) {
    var change = this.state.suppliers_by_certification;
    if(event == null) {
      change[index][name] = null;
    } else {
      change[index][name] = event.value;
    }
    this.setState({suppliers_by_certification: change});
  }

  handleChangeModal (name, index, event) {
    var change = this.state.suppliers_by_certification;
    change[index][name] = event.target.value;
    this.setState({suppliers_by_certification: change});
  }

  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChangeLayout(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;

      var header = this.refs.request_api.header('application/json');
      var self = this;
      this.handleAlert('', '', 'open');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/carregar/layout/'+event.value, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.setState({
            certifications_ids: responseJson.data.certifications_ids,
            staff_ids: responseJson.data.staff_ids,
            aircraft_model_id: responseJson.data.aircraft_model_id,
            aircraft_model_subtype_id: responseJson.data.aircraft_model_subtype_id,
            active: responseJson.data.active,
          });
          self.handleAlert(responseJson.message, responseJson.status, 'closed');
        });
      });
    }
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleSelectChangeMulti(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }

  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  exportCsv(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      certifications_ids: this.state.certifications_ids,
      aircraft_model_id: this.state.aircraft_model_id,
      aircraft_model_subtype_id: this.state.aircraft_model_subtype_id,
      staff_ids: this.state.staff_ids,
      active: this.state.active,
      hide_columns: this.state.hide_columns,
    };

    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/exportar/treinamentos/consolidados', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);
        }
        self.handleAlert('', '', 'closed');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  searchStaffCertifications(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      certifications_ids: this.state.certifications_ids,
      aircraft_model_id: this.state.aircraft_model_id,
      aircraft_model_subtype_id: this.state.aircraft_model_subtype_id,
      staff_ids: this.state.staff_ids,
      active: this.state.active,
      hide_columns: this.state.hide_columns,
    };

    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/controle/treinamentos/consolidados', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({titles: responseJson.data.main.colunas});
          self.setState({linha: responseJson.data.main.linha});
          self.setState({trainings_list: responseJson.data.trainings_list});
          self.setState({payload: datasave});
          self.setState({view_table: 1});
        }
        self.handleAlert('', '', 'closed');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  exportStaffCertifications() {
    this.handleAlert('', '', 'open');
    var datasave = this.state.payload;

    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/controle/treinamentos/consolidados/planilha', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var url = config.get('cdn') + '/tmp/' + responseJson.data;
          self.setState({
            url_export: url,
          });
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);
        }
        self.handleAlert('', '', 'closed');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  openModal() {
    this.setState({modal: true});
  }

  saveLayout(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      name: this.state.name,
      type: 'training_consolidated',
      certifications_ids: this.state.certifications_ids,
      aircraft_model_id: this.state.aircraft_model_id,
      aircraft_model_subtype_id: this.state.aircraft_model_subtype_id,
      staff_ids: this.state.staff_ids,
      active: this.state.active,
    };

    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/layout', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.setState({modal: false, name: null});
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/controle/consolidados/listagens', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({certifications_list: responseJson.data.certifications_list, staff_list: responseJson.data.staff_list, aircraft_models_list: responseJson.data.aircraft_models_list, aircraft_model_subtypes_list: responseJson.data.aircraft_model_subtypes_list, search_layout_list: responseJson.data.search_layout_list});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */ 
    });
  }
  
  rowFormat (cell, row) {
    var botao = (
      <div dangerouslySetInnerHTML={{__html: cell}}></div>
    );

    return botao;
  }

  onRowSelect(row, isSelected, e) {
    let checkbox_marked_ids = this.state.checkbox_marked_ids;
    if (isSelected) {
      checkbox_marked_ids.push(row.id);
    } else {
      for (let i = 0; i < checkbox_marked_ids.length; i++) {
        if(checkbox_marked_ids[i] === row.id) {
          checkbox_marked_ids.splice(i, 1);
        }
      }
    }
    this.setState({checkbox_marked_ids: checkbox_marked_ids});
  }

  onSelectAll(isSelected, rows) {
    let checkbox_marked_ids = [];
    if (isSelected) {
      for (let i = 0; i < rows.length; i++) {
        checkbox_marked_ids.push(rows[i].id);
      }
    }
    this.setState({checkbox_marked_ids: checkbox_marked_ids});
  }

  certificationsModal(event) {
    event.preventDefault();
    if (Array.isArray(this.state.checkbox_marked_ids) && this.state.checkbox_marked_ids.length === 0) {
      this.handleAlert('Escolha ao menos um colaborador.', 'warning', 'open');
    } else {
      var confirm = window.confirm('Não foi preenchido um comunicado de treinamento, deseja que seja criado um novo comunicado de treinamento?');
      if (confirm) {
        if(this.state.add_loading == false){
          this.handleAlert('', '', 'open');
          this.setState({add_loading:true});
          var datasave = {
            certifications_ids: this.state.certifications_ids,
          };
          this.setState({suppliers_by_certification:[]});
          var self = this;
          var header = this.refs.request_api.header('application/json');
          Promise.resolve(header).then(function(value) {
            fetch(config.get('api') + '/certificados/fornecedores/opcoes', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
              self.setState({add_loading:false, suppliers_by_certification: responseJson.data.suppliers_by_certification, training_date_start: responseJson.data.today, training_date_finish: responseJson.data.today, modal_suppliers: true});
              self.handleAlert(responseJson.message, responseJson.status, 'open');
            }).catch((error) => {
              console.error(error);
            });
          });
        }
      }

    }
  }

  add(event) {
    event.preventDefault();
    if (Array.isArray(this.state.checkbox_marked_ids) && this.state.checkbox_marked_ids.length === 0) {
      this.handleAlert('Escolha ao menos um colaborador.', 'warning', 'open');
    } else {
      if(this.state.add_loading == false){
        this.handleAlert('', '', 'open');
        this.setState({add_loading:true});
        var datasave = {
          checkbox_marked_ids: this.state.checkbox_marked_ids,
          training_id: this.state.training_id,
        };
        this.setState({checkbox_marked_ids:[]});
        var self = this;
        var header = this.refs.request_api.header('application/json');
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '/treinamento/certificados/colaboradores', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.setState({add_loading:false});
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch((error) => {
            console.error(error);
          });
        });
      }
    }
  }

  // Salva os certificados de um treinamento
  saveModalCertifications(event) {
    event.preventDefault();
    if(this.state.add_loading == false){
      this.handleAlert('', '', 'open');
      this.setState({add_loading:true});
      var datasave = {
        checkbox_marked_ids: this.state.checkbox_marked_ids,
        suppliers_by_certification: this.state.suppliers_by_certification,
        training_name: this.state.training_name,
        training_date_start: this.state.training_date_start,
        training_date_finish: this.state.training_date_finish,
      };
      this.setState({checkbox_marked_ids:[], suppliers_by_certification:[], modal_suppliers: false});
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/treinamento/certificados/colaboradores', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.setState({add_loading:false});
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  sortDate(a, b, order, sortField) {
    var field = sortField.replace('_str', '');
    var columnA = Date.parse(a[field]) || 0;
    var columnB = Date.parse(b[field]) || 0;
    if (order === 'desc') {
      return columnA - columnB;
    } else {
      return columnB - columnA;
    }
  }

  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-fluid">
    <div className="conteudo">
      <h3>{"Controle de Treinamentos Consolidados"}</h3>
      <hr/>
      <form onSubmit={this.searchStaffCertifications}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Layouts:</label>
              <Select
                className=""
                name="layout_id"
                value={this.state.layout_id}
                searchable={true}
                placeholder={'Selecionar colaboradores'}
                onChange={this.handleSelectChangeLayout.bind(this, 'layout_id')}
                options={this.state.search_layout_list}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{"Colaboradores"}:</label>
              <Select
                className=""
                name="staff_ids"
                value={this.state.staff_ids}
                searchable={true}
                multi={true}
                placeholder={"Selecionar Colaboradores"}
                onChange={this.handleSelectChangeMulti.bind(this, 'staff_ids')}
                options={this.state.staff_list}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{"Certificados"}:</label>
              <Select
                className=""
                name="certifications_ids"
                value={this.state.certifications_ids}
                searchable={true}
                multi={true}
                placeholder={"Selecionar Certificados"}
                onChange={this.handleSelectChangeMulti.bind(this, 'certifications_ids')}
                options={this.state.certifications_list}
                required
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{"Frotas designadas"}:</label>
              <Select
                className=""
                name="aircraft_model_id"
                value={this.state.aircraft_model_id}
                searchable={true}
                placeholder={"Selecionar Modelo De Aeronave"}
                onChange={this.handleSelectChangeMulti.bind(this, 'aircraft_model_id')}
                options={this.state.aircraft_models_list}
                multi={true}
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{"Motores designados"}:</label>
              <Select
                className=""
                name="aircraft_model_subtype_id"
                value={this.state.aircraft_model_subtype_id}
                searchable={true}
                placeholder={"Selecionar Modelo De Aeronave"}
                onChange={this.handleSelectChangeMulti.bind(this, 'aircraft_model_subtype_id')}
                options={this.state.aircraft_model_subtypes_list}
                multi={true}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{"Apenas Ativos"}?</label>
              <br/>
              <Toggle
                checked={this.state.active}
                aria-label='No label tag'
                name="active"
                onChange={this.handleToggleChange.bind(this, 'active')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{"Ocultar Campos Padroes De Colaboradores"}?</label>
              <br/>
              <Toggle
                checked={this.state.hide_columns}
                aria-label='No label tag'
                name="hide_columns"
                onChange={this.handleToggleChange.bind(this, 'hide_columns')} />
            </div>
          </div>
        </div>
        <div>
          <button type="submit" className="btn btn-primary btn-block"><i className="fa fa-fw fa-search"></i> {"Buscar"}</button>
        </div>
      </form>
      <hr/>
      <div>
        <button onClick={this.openModal} className="btn btn-success btn-block"><i className="fa fa-fw fa-search"></i> Salvar layout</button>
      </div>
      <hr/>
      {(self.state.view_table == 1) &&
        <button type="button" onClick={() => this.exportStaffCertifications()} className="btn btn-info btn-block"><i className="fa fa-fw fa-file-excel-o"></i> Baixar Planilha</button>
      }
      <hr/>
      {(self.state.view_table == 1) ?
        <form onSubmit={this.add}>
            <div className="form-group">
              <label>Comunicados de treinamento:</label>
              <Select
                className="form-field-name"
                name="training_id"
                value={this.state.training_id}
                searchable={true}
                placeholder={'Selecionar comunicado de treinamento'}
                onChange={this.handleSelectChange.bind(this, 'training_id')}
                options={this.state.trainings_list}
              />
            </div>
            {(this.state.training_id) ?
              <button disabled={(this.state.add_loading == true) ? 'disabled' : ''} type="submit" className="btn btn-primary btn-block"><i className="fa fa-fw fa-plus"></i> Adicionar a comunicado de treinamento</button>
              :
              <button disabled={(this.state.add_loading == true) ? 'disabled' : ''} onClick={this.certificationsModal} className="btn btn-primary btn-block"><i className="fa fa-fw fa-plus"></i> Adicionar a comunicado de treinamento</button>
            }
        </form>
        : ''
      }
      <hr/>
      {(self.state.view_table == 1) ?

        <BootstrapTable data={this.state.linha} pagination={true} striped={true} hover={true} exportCSV={false} options={{exportCSVText: 'Exportar CSV', noDataText: 'Não há treinamentos cadastrados'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar' selectRow={ {
          mode: 'checkbox',
          clickToSelect: true,
          onSelect: this.onRowSelect,
          onSelectAll: this.onSelectAll
          } }
        >

          {Object.keys(self.state.titles).map(function(t) {
            var data = self.state.titles[t];
            if (t > 0) {

              if(self.state.hide_columns == 0) {

                if((data.title == 'Licença' || data.title == 'Regime')) {

                  return (
                    <TableHeaderColumn dataField={data.field} dataFormat={self.rowFormat} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='120'>{data.title}</TableHeaderColumn>
                  );

                } else if (data.title == 'Nome') {

                  return (
                    <TableHeaderColumn dataField={data.field} dataFormat={self.rowFormat} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='350'>{data.title}</TableHeaderColumn>
                  );

                } else if((data.title == 'AVI' || data.title == 'CEL' || data.title == 'GMP' || data.title == 'ASO')) {

                  return (
                    <TableHeaderColumn dataField={data.field} sortFunc={self.sortDate} dataFormat={self.rowFormat} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='120'>{data.title}</TableHeaderColumn>
                  );

                } else {

                  return (
                    <TableHeaderColumn dataField={data.field} sortFunc={self.sortDate} dataFormat={self.rowFormat} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='120'>{data.title}</TableHeaderColumn>
                  );

                }
                
              } else if((data.title !== 'Licença' && data.title !== 'Regime' && data.title !== 'AVI' && data.title !== 'CEL' && data.title !== 'GMP' && data.title !== 'ASO')) {

                return (
                  <TableHeaderColumn dataField={data.field} dataFormat={self.rowFormat} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='120'>{data.title}</TableHeaderColumn>
                );

              }
            } else {
              return (
                <TableHeaderColumn isKey={true} dataField={data.field} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='120'>{data.title}</TableHeaderColumn>
              );

            }
          })}


        </BootstrapTable>
        : ''
      }
      <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
        <Modal.Header>
          <h4 className="pull-left">Layout</h4>
          <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false, name: null})}>
          <i className="fa fa-fw fa-close"></i></button>
          <div className="clearfix"></div>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={this.saveLayout}>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <label>Nome:</label>
                  <input type="text" name="name" className="form-control" placeholder="" value={this.state.name} onChange={this.handleChange.bind(this, 'name')} required />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Salvar</button>
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false, name: null})}>
          <i className="fa fa-fw fa-close"></i></button>
        </Modal.Footer>
      </Modal>
      <Modal show={this.state.modal_suppliers} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
        <Modal.Header>
          <h4 className="pull-left">Fornecedores dos certificados</h4>
          <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal_suppliers: false})}>
          <i className="fa fa-fw fa-close"></i></button>
          <div className="clearfix"></div>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={self.saveModalCertifications}>
            <div className="row">
              <div className="col-md-4 form-group">
                <label>Treinamento:</label>
                <input required type="text" name="training_name" className="form-control" placeholder="" value={self.state.training_name} onChange={self.handleChange.bind(self, 'training_name')} />
              </div>
              <div className="col-md-4 form-group">
                <label>Data inicial:</label>
                <InputMask value={self.state.training_date_start}  maskChar={null} name="training_date_start" mask="99/99/9999" className="form-control" onChange={self.handleChange.bind(self, 'training_date_start')} required placeholder="" />
              </div>
              <div className="col-md-4 form-group">
                <label>Data final:</label>
                <InputMask value={self.state.training_date_finish}  maskChar={null} name="training_date_finish" mask="99/99/9999" className="form-control" onChange={self.handleChange.bind(self, 'training_date_finish')} required placeholder="" />
              </div>
            </div>
            <hr/>
            {Object.keys(self.state.suppliers_by_certification).map(function(certification_id) {
              var certification_data = self.state.suppliers_by_certification[certification_id];
              return (
                <div>
                  <div className="row">
                    <div className="col-md-4 form-group">
                      <label>Certificado:</label>
                      <input disabled type="text" name="type" className="form-control" placeholder="" value={self.state.suppliers_by_certification[certification_id].certification_name} />
                    </div>
                    <div className="col-md-4 form-group">
                      <label>Data inicial:</label>
                      <InputMask value={self.state.suppliers_by_certification[certification_id].date_start}  maskChar={null} name="date_start" mask="99/99/9999" className="form-control" onChange={self.handleChangeModal.bind(self, 'date_start', certification_id)} required placeholder="" />
                    </div>
                    <div className="col-md-4 form-group">
                      <label>Data final:</label>
                      <InputMask value={self.state.suppliers_by_certification[certification_id].date_finish}  maskChar={null} name="date_finish" mask="99/99/9999" className="form-control" onChange={self.handleChangeModal.bind(self, 'date_finish', certification_id)} required placeholder="" />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4 form-group">
                      <label>Fornecedor:</label>
                      <Select
                        className="form-field-name"
                        name="type"
                        value={self.state.suppliers_by_certification[certification_id].certification_supplier_id}
                        searchable={true}
                        placeholder={''}
                        onChange={self.handleSelectChangeModal.bind(self, 'certification_supplier_id', certification_id)}
                        options={self.state.suppliers_by_certification[certification_id].supplier_list}
                        required
                      />
                    </div>
                    <div className="col-md-4 form-group">
                      <label>Período:</label>
                      <input value={self.state.c_hours} name="c_hours" className="form-control" onChange={self.handleChangeModal.bind(self, 'c_hours', certification_id)} placeholder="Período da aula" />
                    </div>
                    <div className="col-md-4 form-group">
                      <label>Tipo de modalidade:</label>
                      <Select
                        className="form-field-name"
                        name="presence_type"
                        value={self.state.suppliers_by_certification[certification_id].presence_type}
                        searchable={true}
                        placeholder={'Selecionar tipo de modalidade'}
                        onChange={self.handleSelectChangeModal.bind(self, 'presence_type', certification_id)}
                        options={[
                        {value: "presencial", label: "Presencial"},
                        {value: "ead", label: "EAD"}
                        ]}
                        required
                      />
                    </div>
                  </div>
                  <hr/>
                </div>
              );
            })}
            <hr/>
            <div className="row">
              <div className="col-md-12">
                <button disabled={(this.state.add_loading == true) ? 'disabled' : ''} type="submit" className="btn btn-primary btn-block"><i className="fa fa-fw fa-plus"></i> Adicionar comunicado de treinamento</button>
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal_suppliers: false})}>
          <i className="fa fa-fw fa-close"></i></button>
        </Modal.Footer>
      </Modal>
    </div>
  </div>
</div>
    );
  }
}

export default StaffCerficationsConsolidated;



// WEBPACK FOOTER //
// ./src/Components/StaffCertifications/StaffCerficationsConsolidated.js